module.exports = __webpack_public_path__ + "img/zijinliushui_you.a2eacd98.png";